import React, { FC} from 'react'

export const Loader: FC = () => {
  return (
    <div className="loader-wrapper">
      <div className="custom-loader"/>  
    </div>
    );
}